<template>
  <div class="error-page">
    <v-container fluid class="error-container">
      <v-row justify="center" align="center" class="error-row">
        <v-col cols="12" md="6" lg="4">
          <v-card class="error-card" elevation="8">
            <v-card-text class="text-center pa-4">
              <div class="error-icon mb-3">
                <v-icon size="60" color="error">mdi-alert-circle-outline</v-icon>
              </div>

              <h1 class="error-title mb-2">404</h1>
              <h2 class="error-subtitle mb-3">頁面未找到</h2>

              <p class="error-description mb-4">
                抱歉，您要尋找的頁面不存在或已被移除。
                <br />
                請檢查網址是否正確，或使用下方的按鈕回到主要頁面。
              </p>

              <div class="error-actions">
                <v-btn color="primary" class="mr-3 desktop-mr" @click="goToHome">
                  <v-icon left>mdi-home</v-icon>
                  回到首頁
                </v-btn>

                <v-btn outlined @click="goBack">
                  <v-icon left>mdi-arrow-left</v-icon>
                  返回上頁
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  methods: {
    goToHome() {
      const currentPath = this.$route.fullPath
      if (currentPath.includes('/contactbook')) {
        this.$router.push('/contactbook/home')
      } else {
        this.$router.push('/whiteboard')
      }
    },
    goBack() {
      if (this.$router.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.goToHome()
      }
    },
  },
}
</script>

<style scoped>
.error-page {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 50%, #1a252f 100%);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-container {
  height: 100%;
  padding: 0;
}

.error-row {
  height: 100%;
  margin: 0;
}

.error-card {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  max-width: 500px;
  margin: 0 auto;
}

.error-icon {
  animation: pulse 2s infinite;
}

.error-title {
  font-size: 3rem;
  font-weight: 700;
  color: #e74c3c;
  margin: 0;
  line-height: 1;
}

.error-subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.error-description {
  font-size: 0.95rem;
  color: #7f8c8d;
  line-height: 1.4;
  margin: 0;
}

.error-actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* 響應式設計 */
@media (max-width: 600px) {
  .error-card {
    margin: 20px;
  }

  .error-title {
    font-size: 2.5rem;
  }

  .error-subtitle {
    font-size: 1.1rem;
  }

  .error-description {
    font-size: 0.9rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .error-actions .v-btn {
    width: 100%;
    max-width: 250px;
  }

  .desktop-mr {
    margin-right: 0 !important;
  }
}
</style>
